import { FeatureName, PermissionValues, useIsFeatureEnabled } from '@gripp/shared-logic';
import moment from 'moment';
import { AddButton } from '../../shared/components/addButton/addButton';
import { CreateForm } from '../../shared/components/forms/mutationForm';
import { ModalButton } from '../../shared/components/modalButton';
import { CREATE_TAG_BATCH } from '../operations/createTagBatch';
import { CreateTagBatchForm } from './createTagBatchForm';
import { TagBatchesToolbar as TagBatchesToolbarOld } from './tagBatchesToolbar-old';

export const TagBatchesToolbar = () => {
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  if (isCropCircleRedesignEnabled) {
    return <TagBatchesToolbarBase />;
  }

  return <TagBatchesToolbarOld />;
};

export const TagBatchesToolbarBase = () => {
  const transformFormSubmission = (data) => {
    return {
      quantity: data.quantity,
      workspace: { id: data.workspace },
      memo: data.memo,
      version: {
        id: '00000000-0000-0000-0000-000000000001',
      },
      status: 'ORDERED',
      name: moment().format('YYYY-MM-DD_HHMMSS'),
    };
  };

  return (
    <ModalButton
      label=""
      customButton={(toggleVisibility) => (
        <AddButton onPress={() => toggleVisibility(true)} />
      )}
      requiredPermission={PermissionValues.tagbatch.create}
      modalComponent={({ onComplete }) => {
        return (
          <CreateForm
            defaultValues={{
              quantity: '',
              workspace: '',
              memo: '',
            }}
            formComponent={CreateTagBatchForm}
            modelName="tagbatch"
            mutationOperation={CREATE_TAG_BATCH}
            invalidateCache={true}
            dataTransformer={transformFormSubmission}
            onComplete={onComplete}
          />
        );
      }}
    />
  );
};